module.exports = __webpack_public_path__ + "static/img/s46.3ee7688a.png";